import React from 'react';


const AppHeader = () => (
  <div className="App-header">
    <h2>Fuse Filter Demo</h2>
  </div>
);

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/AppHeader.jsx